import { render } from "./DialogLoading.vue?vue&type=template&id=08f37608"
import script from "./DialogLoading.vue?vue&type=script&lang=js"
export * from "./DialogLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__